<template>
  <div id="XtDesignContainer" ref="XtDesignContainer" v-loading="messageInfo.isShow"
    :element-loading-text="messageInfo.message" element-loading-background="rgba(255,255,255,0.7)">
    <leftNav :key="updateKey" :folder-chain="folderChain"></leftNav>
    <rightMain></rightMain>
  </div>
</template>

<script>
import { mapState } from "vuex";
import leftNav from "./leftNav/leftNav";
import rightMain from "./rightMain/rightMain";

export default {
  name: "XtDesign",
  components: {
    leftNav,
    rightMain
  },
  data() {
    return {
      updateKey: 0
    };
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      messageInfo: (state) => state.XtDesign.messageObj
    }),
    folderChain() {
      return this.$route?.params?.folderChain;
    }
  },
  watch: {
    prjInfo: {
      deep: true,
      handler: function ({ prjId }, oldValue) {
        if (prjId) {
          this.$store.dispatch("XtDesignUpdateMessageObj", {
            isShow: true,
            message: "数据加载中..."
          });
          this.updateKey += 1;
        }
      }
    }
  },
  created() {
    this.$store.dispatch("XtDesignUpdateLRWidth", { lw: "", rw: "" });
    this.$store.dispatch("XtDesignUpdateMessageObj", {
      isShow: true,
      message: "数据加载中..."
    });
  },

  mounted() {}
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
#XtDesignContainer {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  position: relative;
  user-select: none;
}
</style>
